import React from 'react'
import First from '../Menshopdeatils/First'
import Bredcom from '../../Bredcom/Main'

function Main() {
  return (
    <>
        <Bredcom title="Shop Details" subtitle="Home" subtitledown="Pricing" />
        <First/>
    </>
  )
}

export default Main